function calculateScore() {
    const q1 = document.getElementById("TestSubmissionForm-question1");
    const q2 = document.getElementById("TestSubmissionForm-question2");
    const q3 = document.getElementById("TestSubmissionForm-question3");
    const q4 = document.getElementById("TestSubmissionForm-question4");
    const q5 = document.getElementById("TestSubmissionForm-question5");
    const q6 = document.getElementById("TestSubmissionForm-question6");
    const q7 = document.getElementById("TestSubmissionForm-question7");
    const q8 = document.getElementById("TestSubmissionForm-question8");
    const q9 = document.getElementById("TestSubmissionForm-question9");
    const q10 = document.getElementById("TestSubmissionForm-question10");
    const q11 = document.getElementById("TestSubmissionForm-question11");
    const q12 = document.getElementById("TestSubmissionForm-question12");
    const q13 = document.getElementById("TestSubmissionForm-question13");
    const q14 = document.getElementById("TestSubmissionForm-question14");
    const q15 = document.getElementById("TestSubmissionForm-question15");
    const q16 = document.getElementById("TestSubmissionForm-question16");
    const q17 = document.getElementById("TestSubmissionForm-question17");

    let answers = [];
    answers.push(q1, q2, q3, q4, q5, q6, q7, q8, q9, q10, q11, q12, q13, q14, q15, q16, q17);

    let score = 0;
    let results = [];
//   add x for incorrect answers on test results page
  	let x = [];
        
    for (let i = 0; i < answers.length; i++) {
        const answer = answers[i].options[answers[i].selectedIndex].value;
		let aIndex = answers[i].selectedIndex;

        // push answers into results array
        results.push(answer);
        
        // 1
        if (answer === "Loose Curls and Waves (2), Spiral Curls (2C-3B), Tight Curls (3C-4A), All Coils (4)") {
            score += 1;
          	x.push('correct');
        } 
        // 2
        else if (answer === "Curl Shaper, VitalCurl+, Curl Quencher, Coil Infusion") {
            score += 1;
          	x.push('correct');
        }
        // 3
        else if (answer === "5") {
            score += 1;
          	x.push('correct');
        }
        // 4
        else if (answer === "Rake & Shake") {
            score += 1;
          	x.push('correct');
        }
        // 5
        else if (answer === "Lack of moisture") {
            score += 1;
          	x.push('correct');
        }
        //6
        else if (answer === "They both have a lifted cuticle") {
            score += 1;
          	x.push('correct');
        }
        // 7
        else if (answer === "On the first time visit as part of the Ouidad Experience") {
            score += 1;
          	x.push('correct');
        }
        // 8
        else if (answer === "All of the above") {
            score += 1;
          	x.push('correct');
        }
        // 9
        else if (answer === "Advanced Climate Control Heat Detangling Spray, Moisture Lock Leave-in Conditioner, Whipped Curls") {
            score += 1;
          	x.push('correct');
        }
        // 10
        else if (answer === "Mongongo Oil, Clear Control Pomade, Shine Glaze Serum ") {
            score += 1;
          	x.push('correct');
        }
        // 11
        else if (answer === "Color It My Way Temporary Hair Colorant") {
            score += 1;
          	x.push('correct');
        }
        // 12
        else if (answer === "Curl Last Flexible-Hold Hairspray") {
            score += 1;
          	x.push('correct');
        }
        // 13
        else if (answer === "Advanced Climate Control Line") {
            score += 1;
          	x.push('correct');
        }
        // 14
        else if (answer === "Curl Shaper Line") {
            score += 1;
          	x.push('correct');
        }
        // 15
        else if (answer === "VitalCurl+ Line") {
            score += 1;
          	x.push('correct');
        }
        // 16
        else if (answer === "Curl Quencher Line") {
            score += 1;
          	x.push('correct');
        }
        // 17
        else if (answer === "Coil Infusion Line") {
            score += 1;
          	x.push('correct');
        } else {
        	x.push('wrong');
        }
    }

    sessionStorage.setItem("score", score);
    sessionStorage.setItem("answers", JSON.stringify(results));
  	sessionStorage.setItem("x", JSON.stringify(x));
    
    // Send score value to the form
    const scoreInput = document.getElementById("TestSubmissionForm-score");
    scoreInput.value = score;
}